import React, { useContext, useEffect, useState } from "react";

import { useMemo } from "react";
import styles from "./styles/Trustees.module.css";
import { Beneficiarytrustee } from "../Beneficiarytrustee/Beneficiarytrustee";
import TableFilter from "./TableFilter";
import { TrusteesTable } from "./TrusteesTable";
import NewTrustee from "../Add Trustee/NewTrustee";
import ApprovalModal from "../Partner Approval/ApprovalModal";
import { isPendingApproval, needsReview } from "../../../Utils/partnerApproval";
import { getPartner } from "../Partner Sharing/PartnerSharing";
import { UserData } from "../../../Context/DataContext";
import AssetType from "./Asset Type/AssetType";
import EditTrustee from "../Edit Trustee/EditTrustee";
import { useRef } from "react";
import InfoTitle from "../Info/InfoTitle";
import Rect from "../Rect/Rect";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import useWindowDimensions from "../../Footer/footer";
import { PageHeading } from "../PartnerNav/PageHeading";

function Trustees() {
  const userData = UserData();
  /*
    The advisors this tab lists.

    An advisor sent only because a shared asset names them is not a record the
    customer shared -- their name labels that asset and nothing more -- so they
    are left out here. Everything the customer shared outright is unaffected,
    and on their own account nothing carries the flag at all.
  */
  const listedTrustees = (userData.UserData.trustees || []).filter(
    (t) => t?.shared_as_record !== false
  );
  const [data, setData] = useState(listedTrustees);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  // The advisor whose approval interstitial is open.
  const [reviewing, setReviewing] = useState(null);
  const [toEdit, setToEdit] = useState();
  const [filter, setFilter] = useState();
  const mobileRef = useRef();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const approvalContent =
    websiteCurrentLang?.content?.User?.PartnerApproval?.PartnerApproval;
  const { height, width } = useWindowDimensions();

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AssetType.Trustees
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    window.scrollTo(0, 0);
    setContent(websiteCurrentLang.content.User.AssetType.Trustees);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    setData(
      (userData.UserData.trustees || []).filter(
        (t) => t?.shared_as_record !== false
      )
    );

    // const Weglot = document.createElement("script")
    // Weglot.src = "https://cdn.weglot.com/weglot.min.js"
    // document.body.appendChild(Weglot)
    // Weglot.onload = () =>{
    //   console.log('Script is loaded')
    //   window.Weglot.initialize({
    //     api_key: 'wg_fe59e91dbf7c41abd8908f1b88215ff17',
    //   });
    // }
  }, [openAdd, openEdit, userData.UserData.trustees]);

  let trusteeNameMaxLength = 50;
  if (width <= 550) {
    trusteeNameMaxLength = 35;
  }
  if (width <= 350) {
    trusteeNameMaxLength = 25;
  }
  const columns = useMemo(
    () => [
      {
        Header: content.trusteesText1,
        accessor: "name",
        Cell: ({ row, value }) => {
          var assets = [];
          let user_id = row.original.user_id;
          userData.UserData.assets.map((asset) => {
            if (asset.trustees.includes(user_id))
              assets.push(
                <AssetType
                  key={asset.asset_id}
                  asset_name={asset.asset_name}
                  asset_type={asset.asset_type}
                  removable={false}
                />
              );
            return null;
          });
          let turstee_user_id = row.original.user_id;
          let beneficiaries_logo = [];
          userData.UserData.beneficiaries.map((e) => {
            if (e.trustees.includes(turstee_user_id))
              beneficiaries_logo.push(
                <Beneficiarytrustee
                  name={e.name + "" + e.last_name}
                  priority={e.priority}
                />
              );
            return null;
          });
          const trustee = userData.UserData.trustees.filter(
            (truste) => truste.user_id === user_id
          )[0];

          // const beneficiary_row = <div className={styles.beneficiary_list} key={Math.random().toString()}>{beneficiaries_logo}</div>
          return (
            <>
              <div className={styles.asset_name}>
                {/* check here */}
                <Beneficiarytrustee
                  avatar={
                    trustee?.profile_avatar ? trustee.profile_avatar : null
                  }
                  name={value}
                  priority={0}
                  /* 32px, the size Asset Management draws these at. */
                  styling={{ width: "32px", height: "32px" }}
                  textFontSize="11px"
                />
                <div
                  className={styles.nameTableText}
                  style={
                    width > 767
                      ? {
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          width: "80%",
                          lineClamp: 1,
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          display: "-webkit-box",
                          wordBreak: "break-all",
                        }
                      : {
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          width: "80%",
                          lineClamp: 2,
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          display: "-webkit-box",
                          wordBreak: "break-all",
                        }
                  }
                >
                  {/* {value.length > trusteeNameMaxLength ? (
                    <>{value.slice(0, trusteeNameMaxLength) + "..."}</>
                  ) : (
                    <>{value}</>
                  )} */}
                  {value}
                </div>
                {/*
                  Created by the partner and not approved yet. Until it is, this
                  advisor is attached to nothing and answers no attention point.
                */}
                {/* Created by the partner, or changed by them -- either way. */}
                {needsReview(trustee) && (
                  <span className={styles.review_marker}>
                    <span aria-hidden="true">!</span>
                    {approvalContent?.partnerApprovalText13}
                  </span>
                )}
                <div
                  ref={mobileRef}
                  className={styles.trustees_mobile_row}
                ></div>
              </div>
              <div
                className={`${styles.mobile_aware} ${styles.aware_status} ${
                  row.original.awareness_status === "true"
                    ? styles.notified
                    : ""
                }`}
              >
                {row.original.awareness_status === "true"
                  ? content.trusteesText2
                  : content.trusteesText3}
              </div>
            </>
          );
        },
      },
      {
        Header: content.trusteesText4,
        accessor: "associated_assets",
        Cell: ({ row, value }) => {
          var assets = [];
          let user_id = row.original.user_id;
          let maxNumber = 5;
          if (width <= 600 && width > 460) {
            maxNumber = 3;
          }
          if (width <= 460) {
            maxNumber = 2;
          }
          userData.UserData.assets.map((asset) => {
            if (asset.trustees.includes(user_id))
              assets.push(
                <AssetType
                  key={asset.asset_id}
                  asset_name={asset.asset_name}
                  asset_type={asset.asset_type}
                  removable={false}
                />
              );
            return null;
          });
          const filteredAssets = assets.slice(0, maxNumber);

          return (
            <>
              <div
                className={styles.table_label}
                style={
                  filteredAssets.length === 0
                    ? {}
                    : {
                        marginBottom: "5px",
                      }
                }
              >
                {content.trusteesText4}
              </div>
              <div
                style={{ display: "flex", gap: "6px", alignItems: "center" }}
              >
                {assets.length ? (
                  <>
                    {filteredAssets}
                    {assets.length > maxNumber && (
                      <span
                        className={styles.more}
                        style={{
                          transform: "translateY(-4px)",
                        }}
                      >
                        ...
                      </span>
                    )}
                  </>
                ) : (
                  <div className={styles.no_items}>
                    {dublicatedcontent.dublicatedText66}
                  </div>
                )}
              </div>
            </>
          );
        },
      },
      {
        Header: content.trusteesText5,
        accessor: "associated_beneficiaries",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          let turstee_user_id = row.original.user_id;
          let beneficiaries_logo = [];
          let maxNumber = 5;
          if (width <= 600 && width > 460) {
            maxNumber = 3;
          }
          if (width <= 460) {
            maxNumber = 2;
          }
          userData.UserData.beneficiaries.map((e) => {
            if (e.trustees.includes(turstee_user_id)) {
              const avatar = userData?.UserData?.beneficiaries?.filter(
                (y) => y.user_id === e.user_id
              )[0]?.profile_avatar;

              beneficiaries_logo.push(
                <Beneficiarytrustee
                  /*
                    Same 32px as everywhere else. The 5px bottom margin went
                    with the old side-by-side layout; these overlap now and
                    .beneficiary_list centres them.
                  */
                  styling={{ width: "32px", height: "32px" }}
                  textFontSize="11px"
                  avatar={avatar}
                  name={e.name}
                  priority={e.priority}
                />
              );
            }
            return null;
          });
          const filteredBeneficiaries = beneficiaries_logo.slice(0, maxNumber);
          return (
            <>
              <div
                className={styles.table_label}
                style={
                  filteredBeneficiaries.length === 0
                    ? {}
                    : {
                        marginBottom: "5px",
                      }
                }
              >
                {content.trusteesText5}
              </div>
              {beneficiaries_logo.length ? (
                <div
                  className={styles.beneficiary_list}
                  key={Math.random().toString()}
                >
                  {filteredBeneficiaries}
                  {beneficiaries_logo.length > maxNumber && (
                    <span className={styles.more}>...</span>
                  )}
                </div>
              ) : (
                <div className={styles.no_items}>
                  {dublicatedcontent.dublicatedText66}
                </div>
              )}
            </>
          );
        },
      },
      {
        Header: content.trusteesText7,
        accessor: "awareness_status",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          // return (<span key={Math.random().toString()}>{pics}</span>)
          return (
            <div
              className={`${styles.aware_status} ${
                value === "true" ? styles.notified : ""
              }`}
              key={Math.random().toString()}
            >
              {value === "true" ? content.trusteesText2 : content.trusteesText3}
            </div>
          );
        },
      },
      {
        Header: content.trusteesText8,
        id: "AssetsBeneficiaries",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          var assets = [];
          let user_id = row.original.user_id;
          userData.UserData.assets.map((asset) => {
            if (asset.trustees.includes(user_id))
              assets.push(
                <AssetType
                  key={asset.asset_id}
                  asset_name={asset.asset_name}
                  asset_type={asset.asset_type}
                  removable={false}
                />
              );
            return null;
          });
          const assets_row = (
            <div
              style={{
                display: "flex",
                gap: "6px",
                alignItems: "center",
              }}
            >
              {assets}
            </div>
          );
          let turstee_user_id = row.original.user_id;
          let beneficiaries_logo = [];
          userData.UserData.beneficiaries.map((e) => {
            if (e.trustees.includes(turstee_user_id))
              beneficiaries_logo.push(
                <Beneficiarytrustee
                  name={e.name + "" + e.last_name}
                  priority={e.priority}
                  /*
                    The mobile card draws the same .beneficiary_list, so
                    these overlap now too — at the same 32px as the
                    desktop rows, not the component's 50px default.
                  */
                  styling={{ width: "32px", height: "32px" }}
                  textFontSize="11px"
                />
              );
            return null;
          });
          const beneficiary_row = (
            <div
              className={styles.beneficiary_list}
              key={Math.random().toString()}
            >
              {beneficiaries_logo}
            </div>
          );
          return (
            <div ref={mobileRef} className={styles.trustees_mobile_row}>
              <div>{assets_row}</div>
              <div>{beneficiary_row}</div>
            </div>
          );
        },
      },
    ],
    [
      userData.UserData.beneficiaries,
      userData.UserData.assets,
      userData.UserData.trustees,
      approvalContent,
      content,
    ]
  );
  // {
  //   Header: "Action",
  //   id: "expander",
  //   Cell: ({ row }) => (

  //     <div className={styles.action_button} onClick={()=>{setToEdit(row.original);setOpenEdit(true)}}></div>
  //   )
  // }

  const handleClick = (data) => {
    /*
      An advisor the partner created and the customer has not approved: the
      explanation comes first, and only then the ordinary edit modal.
    */
    if (isPendingApproval(data) && !userData.partnerReadOnly) {
      setReviewing(data);
      return;
    }
    /*
      A partner may open any advisor shared with them -- the modal opens
      read-only unless it is their own unapproved draft. See canEditRecord.
    */
    if (!window.getSelection().isCollapsed) {
      return;
    } else {
      setToEdit(data);
      setOpenEdit(true);
    }
  };
  return (
    <>
      <div className={styles.main_box}>
        <PageHeading className={styles.page_title}>
          {dublicatedcontent.dublicatedText26.replace(" - ", "")}
        </PageHeading>
        <InfoTitle
          message={content.trusteesText9}
          title={content.trusteesText10}
        />
        <div className={styles.table_div}>
          <TableFilter
            disabled={userData.isFreezed}
            filter={filter}
            setFilter={setFilter}
            OnAddNewAsset={() => setOpenAdd(true)}
          />
          {data ? (
            <TrusteesTable
              click={(data) => handleClick(data)}
              columns={columns}
              data={data}
              filter={filter}
              setFilter={setFilter}
              trusteesLength={userData.UserData.trustees}
              scrollToTop={true}
            />
          ) : null}
        </div>
        <div style={{ position: "relative", zIndex: 6 }}>
          {reviewing && (
            <ApprovalModal
              subject="trustee"
              partnerName={getPartner(userData)?.name}
              onClose={() => setReviewing(null)}
              onStart={() => {
                const advisor = reviewing;
                setReviewing(null);
                setToEdit(advisor);
                setOpenEdit(true);
              }}
            />
          )}
          {openAdd ? <NewTrustee onClose={() => setOpenAdd(false)} /> : null}
          {openEdit ? (
            <EditTrustee toEdit={toEdit} onClose={() => setOpenEdit(false)} />
          ) : null}
        </div>
      </div>
      <Rect />
    </>
  );
}

export default Trustees;
